import { NavLink, Outlet } from 'react-router-dom';

// Settings shell: a section list plus an <Outlet/> for the active section.
// Only "Developer tokens" exists today, but the sub-nav is here from the start so
// adding a section is a route entry rather than a re-layout — and so the URL
// (/settings/tokens) already names its section instead of being the whole page.
//
// Reached from the sidebar user menu. Iteration 2.0 has no top nav, so nothing
// else links here.
const SECTIONS: ReadonlyArray<{ to: string; label: string }> = [
  { to: '/settings/tokens', label: 'Developer tokens' },
];

export default function SettingsPage() {
  return (
    <section className="settings">
      <h1 className="settings__title">Settings</h1>

      <div className="settings-layout">
        {/* No className function here on purpose: NavLink adds `active` itself,
            and the stylesheet targets that. */}
        <nav className="settings-nav" aria-label="Settings sections">
          {SECTIONS.map((section) => (
            <NavLink key={section.to} to={section.to}>
              {section.label}
            </NavLink>
          ))}
        </nav>

        <div className="settings-content">
          <Outlet />
        </div>
      </div>
    </section>
  );
}
